import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

/**
 * ### **RoutesSkeletonComponent**
 *
 * **Selector:** ``<app-routes-skeleton>
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar el esqueleto de precarga para la lista de rutas turísticas.
 */
@Component({
  selector: 'app-routes-skeleton',
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./routes-skeleton.component.html",
  styleUrl: "./routes-skeleton.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutesSkeleton implements OnInit {
  /** Variable de entrada que recibe del componente padre el numero de objetos que debe renderizar*/
  readonly numbersLoading = input.required<number>();
  /** Variable que guarda la lista de iteradores*/
  protected readonly numbersIterate = signal<number[]>([]);

  /** @ignore*/
  constructor() {}
  /**
   * Función nativa de angular que se carga despues del constructor si no hay un onChanges,
   * aqui incializa el valor de numbersIterate.
   */
  ngOnInit() {
    this.numbersIterate.set(
      Array(this.numbersLoading())
        .fill(0)
        .map((x, i) => i)
    );
  }
}
